import { INICIALITZAR } from "./actionTypes";

export const esborrarValors = () => {
  return {
    type: INICIALITZAR
  };
};
